/**
 * Manages office pins
 * @param map  the instance of the map the layer exists in
 */
define(['bing', 'c21/maps', 'c21/maps/UniqueLocationStore', 'c21/maps/InfinitePinScrollLayer', 'c21/track', 'jquery'], function () {
   "use strict";

   return function (map, officeTooltipManager) {
      var self = this,

         $ = require('jquery'),
         track = require('c21/track'),
         C21Maps = require('c21/maps'),
         BingMaps = require('bing'),
         UniqueLocationStore = require('c21/maps/UniqueLocationStore'),
         InfinitePinScrollLayer = require('c21/maps/InfinitePinScrollLayer'),

         m_layer = new BingMaps.Layer(),
         m_map = map,

         m_aPinData,
         m_oPinById,
         m_oShadowPinById,
         m_pinDataById,

         refreshPin = function (iPinId, bVisible) {
            m_oPinById[iPinId].setOptions({
               visible: bVisible
            });
            m_oShadowPinById[iPinId].setOptions({
               visible: bVisible
            });
         },

         m_officeTooltipManager = officeTooltipManager,
         m_uniqueLocationStore = new UniqueLocationStore(),
         m_infinitePinScrollLayer = new InfinitePinScrollLayer(m_officeTooltipManager, refreshPin),

         createPin = function (pinData) {
            var loc = pinData.getLocation(),
               pin = new BingMaps.Pushpin(loc, {
                  icon: '/images/search/office-pushpin-icon.png',
                  // Width not including the shadow
                  width: 42,
                  height: 60,
                  typeName: 'officePin',
                  zIndex: C21Maps.getZindexFromLoc(
                     pinData.getLatitude(),
                     pinData.getLongitude()
                  ),
                  visible: false,
                  anchor: new BingMaps.Point(20, 59)
               }),
               shadowPin = new BingMaps.Pushpin(loc, {
                  icon: '/images/search/office-pushpin-shadow.png',
                  width: 63,
                  height: 60,
                  typeName: 'officePin',
                  zIndex: 1,
                  visible: false,
                  anchor: new BingMaps.Point(20, 59)
               }),
               id = pinData.getId();

            C21Maps.onPinHoverIntent(m_map, pin, function () {
               track.doEvent('Mapping', 'Hover over an office on the map in office view');
               m_officeTooltipManager.showHoverTooltip(pinData);
            }, function () {
               m_officeTooltipManager.hideHoverTooltip();
            });

            BingMaps.Events.addHandler(pin, 'click', function (e) {
               track.doEvent('Mapping', 'Click on an office on the map in office view');
               m_officeTooltipManager.showClickTooltip(pinData);
            });

            m_layer.add(pin);
            m_layer.add(shadowPin);

            m_oPinById[id] = pin;
            m_oShadowPinById[id] = shadowPin;
            m_pinDataById[id] = pinData;

            return pin;
         },

         initialize = function () {
            m_layer.setZIndex(4);
            m_map.layers.insert(m_layer);
            C21Maps.onMapClick(m_map, function (e) {
               m_officeTooltipManager.clear();
            });
         };

      self.clearOffices = function () {
         m_aPinData = [];
         m_oPinById = {};
         m_oShadowPinById = {};
         m_pinDataById = {};
         m_layer.clear();
         m_uniqueLocationStore.clear();
         m_officeTooltipManager.clear();
         m_infinitePinScrollLayer.clear();
      };

      self.setOffices = function (aPinData) {
         self.clearOffices();
         self.addOffices(aPinData);
      };

      self.addOffices = function (aPinData) {
         m_aPinData.concat(aPinData);
         $.each(aPinData, function (i, pinData) {
            if (!m_uniqueLocationStore.add(pinData.getLatitude(), pinData.getLongitude())) {
               return;
            }

            createPin(pinData);
         });
      };

      self.setPinsInView = function (aPinId) {
         m_infinitePinScrollLayer.setPinsInView(aPinId, m_pinDataById);
      };

      initialize();
   };
});
